export default "__VITE_ASSET__BfblJFs___"